'use client';

import React, { useState, useEffect } from 'react';

import { useGlobal } from '@/contexts/GlobalContext';
import { useModal } from '@/contexts/ModalContext';
import MyBoardsModal from '@/components/tacticalboard/MyBoardsModalV2';
import { TacticalboardJson } from '@/types/scenes';

interface SelectTacticalboardProps {
  propsTacticalboardJsonString?: string;
  onSelectTacticalBoard: (data: string) => void;
  onUnselectTacticalBoard: () => void;
}

const SelectTacticalboard: React.FC<SelectTacticalboardProps> = ({
  propsTacticalboardJsonString,
  onSelectTacticalBoard,
  onUnselectTacticalBoard
}) => {
  /**
   * react context
   */
  const content = useGlobal();
  const { openModal, closeModal } = useModal();

  /**
   * useState
   */
  const [imageData, setImageData] = useState<string | undefined>();

  const handleSelectImage = (data: string) => {
    setImageData(data);
    onSelectTacticalBoard(data);
  };

  const handleCancelImage = () => {
    setImageData(undefined);
    onUnselectTacticalBoard();
  };

  useEffect(() => {
    if (propsTacticalboardJsonString != null) {
      const tacticalboardJson: TacticalboardJson = JSON.parse(propsTacticalboardJsonString) as TacticalboardJson;
      setImageData(
        `${
          import.meta.env.PROD
            ? `${tacticalboardJson.imageSource}`
            : `${import.meta.env.VITE_FOOTBALLLOG_BACKEND_DOMAIN}${tacticalboardJson.imageSource}`
        }`
      );
    }
  }, []);

  return (
    <>
      {imageData ? (
        <div
          className="flex justify-center rounded-lg w-full h-48 bg-gray-100 bg-cover bg-center relative"
          // style={{ backgroundImage: "url('/images/backgroundField.jpg')" }}
        >
          <img
            src={imageData}
            alt="img"
            className="object-cover"
            sizes="(min-width: 808px) 100vw, 100vw"
            style={{
              objectFit: 'contain',
              height: '100%'
            }}
          />
          <button
            type="button"
            onClick={handleCancelImage}
            className="absolute top-2 right-2 flex items-center justify-center w-6 h-6 rounded-full text-white bg-gray-300 bg-opacity-60 hover:bg-gray-300 hover:bg-opacity-100 text-sm dark:hover:bg-gray-600 dark:hover:text-white">
            <svg
              className="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14">
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
            <span className="sr-only">Close menu</span>
          </button>
        </div>
      ) : (
        <button
          className="flex flex-col justify-center items-center hover:opacity-80 w-56 h-32 rounded-lg border border-gray-300 bg-cover bg-center text-green-500"
          style={{ backgroundImage: "url('/images/field.jpg')" }}
          type="button"
          onClick={() => openModal(<MyBoardsModal closeModal={closeModal} onSelectImage={handleSelectImage} />)}>
          <div
            className="p-3 bg-green-500 rounded-full"
            style={{ background: content.team?.color_a, color: content.team?.color_b }}>
            <svg
              className="w-4 h-4 text-white dark:text-white"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 18 18">
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M9 1v16M1 9h16"
              />
            </svg>
          </div>
        </button>
      )}
    </>
  );
};

export default SelectTacticalboard;
